module.exports = __webpack_public_path__ + "img/Scott.7fd63997.png";